module.exports = __webpack_public_path__ + "img/hzal.3489b805.png";